module.exports = __webpack_public_path__ + "img/DangerNew.c8d26109.png";